import getColor from "@insite/mobius/utilities/getColor";

export default {
    small: `0 0 1px 0 ${getColor("shadow.light")}, 0 4px 8px 0 ${getColor("shadow.base")}`,
    main: `0 0 1px 0 ${getColor("shadow.light")}, 0 8px 16px 0 ${getColor("shadow.base")}`,
};
